var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-notification',{attrs:{"type":"is-info","closable":false}},[_c('i',{staticClass:"icon-ic_alert-blue"}),_c('strong',[_vm._v(_vm._s(_vm.infoTitle))]),_vm._v("\n    "+_vm._s(_vm.infoText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }